// Опрос раз в intervalMs, пока enabled и вкладка видима. Скрыта (visibilityState === 'hidden') —
// опрос на паузе; вернулись — сразу один запрос, дальше по расписанию от этого момента.
// Первый запрос при включении делает вызывающий код (ему нужно сбросить старые данные).
import { useEffect, useRef } from 'react';

export function useVisiblePolling(enabled, intervalMs, tick) {
  const tickRef = useRef(tick);
  tickRef.current = tick;

  useEffect(() => {
    if (!enabled) return undefined;
    let timer = null;
    const start = () => {
      clearInterval(timer);
      timer = setInterval(() => tickRef.current(), intervalMs);
    };
    const onVisibility = () => {
      if (document.visibilityState === 'visible') {
        tickRef.current();
        start();
      } else {
        clearInterval(timer);
        timer = null;
      }
    };
    if (document.visibilityState === 'visible') start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => {
      clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisibility);
    };
  }, [enabled, intervalMs]);
}
